<template>
  <PageLayout class="mini-kasko-page">
    <MiniKaskoCalculator />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import MiniKaskoCalculator from '../../views/miniKasko/Calculator.vue';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { PageLayout, MiniKaskoCalculator },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>
